import { TerminalIllnessAssessmentDetailsView } from '../../assessment/decisions';
import { TerminalIllnessSynopsis } from '../../assessment/synopsis/terminal-illness/terminal-illness-synopsis';
import { ClaimAuditTrailView } from '../../claim-audit-trail';
import { DashboardFlowView } from '../../assesor-dashboard/views/dashboard/assessor-dashboard';
import { ClaimType } from '../../claim/claim-types';
import { PaymentsView } from '../../payment';
import { WorkflowScreen } from '../../workflow-navigation/reducers/workflow-screen';
import { WorkflowStep } from '../../workflow-navigation/reducers/workflow-step';
import { WorkflowUtilityScreen } from '../../workflow-navigation/reducers/workflow-utility-screen';
import { WorkflowAssessorScreen } from '../../workflow-navigation/reducers/workflow-assessor';
import { ClaimWorkflow } from './claim-workflow';
import { ScreenGuard } from './screen-index';

import { AuthGuard } from '../../auth/authGuard';
import { LivingLifestyleSynopsis } from '../../assessment/synopsis/living-lifestyle/living-lifestyle-synopsis';

const assessorDashboardGuard = AuthGuard(['AssessorDashboard']);
const underwritingGuard = AuthGuard(['Underwriting', 'Agent']);

export const terminalIllnessWorkflow = new ClaimWorkflow(
    'Terminal Illness',
    [
        new WorkflowStep('Initiate Claim', []),
        new WorkflowStep('Assessment', [
            new WorkflowScreen(
                'Synopsis',
                TerminalIllnessSynopsis,
                undefined,
                undefined,
                ScreenGuard
            ),
            new WorkflowScreen(
                'Decisions',
                TerminalIllnessAssessmentDetailsView,
                undefined,
                undefined,
                ScreenGuard
            ),
        ]),
        new WorkflowStep('Underwriting', [
            new WorkflowScreen(
                'Synopsis ',
                LivingLifestyleSynopsis,
                undefined,
                undefined,
                underwritingGuard
            ),
            new WorkflowScreen(' ', undefined, undefined, undefined, underwritingGuard),
        ]),
        new WorkflowStep('Payments', [
            new WorkflowScreen('Payments', PaymentsView, undefined, undefined, () => false),
        ]),
        new WorkflowAssessorScreen(
            'Assessor List',
            'Assessor limits dashboard',
            DashboardFlowView,
            undefined,
            'Assessor limits dashboard',
            assessorDashboardGuard
        ),
        new WorkflowUtilityScreen(
            'Claim Audit Trail',
            'list',
            ClaimAuditTrailView,
            undefined,
            undefined,
            ScreenGuard
        ),
    ],
    claim => claim.claimType === ClaimType.TerminalIllness,
    undefined,
    ScreenGuard
);
